import React, { useState, useEffect } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { useToast } from '../context/ToastContext';

// Konstante für Auto-Hide Delay
const TOAST_AUTO_HIDE_DELAY = 5000; // 5 Sekunden

const ToastNotification = () => {
  const { toast, hideToast } = useToast();
  const [toastLiveMessage, setToastLiveMessage] = useState(''); // Für Screenreader

  // Screenreader-Ankündigung wenn Toast sich ändert
  useEffect(() => {
    if (!toast.show) return undefined;

    const prefix = toast.variant === 'success' ? 'Erfolg' : 'Fehler';
    setToastLiveMessage(`${prefix}: ${toast.message}`);
    // A11Y-M5: 3s statt 1s — gibt Screenreadern genug Zeit die Nachricht zu lesen
    const timer = setTimeout(() => setToastLiveMessage(''), 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [toast.id, toast.show, toast.variant, toast.message]);

  // Auto-Hide Timer mit Memory Leak Prevention
  useEffect(() => {
    if (!toast.show) return undefined;

    const timer = setTimeout(() => {
      hideToast();
    }, TOAST_AUTO_HIDE_DELAY);

    // Cleanup-Funktion: Verhindert Memory Leaks und alte Timer verstecken keine neuen Toasts.
    return () => {
      clearTimeout(timer);
    };
  }, [toast.id, toast.show, hideToast]);

  return (
    <>
      {/* Dedizierte Live Region für Screenreader (WCAG 2.1 Level AA) */}
      <div
        className="visually-hidden"
        role="status"
        aria-live="assertive"
        aria-atomic="true"
        id="toast-live-region"
      >
        {toastLiveMessage}
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-end"
        className="p-3"
        id="notification-toast-container"
      >
        <Toast
          show={toast.show}
          onClose={hideToast}
          bg={toast.variant}
          id="notification-toast"
        >
          <Toast.Header closeButton id="notification-toast-header">
            <strong className="me-auto">
              <span aria-hidden="true">
                {toast.variant === 'success' ? '✓ ' : '✗ '}
              </span>
              {toast.variant === 'success' ? 'Erfolg' : 'Fehler'}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white" id="notification-toast-body">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ToastNotification;
